import React from "react";
import { AppBar, Box, Container, Toolbar, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LoginIcon from "@mui/icons-material/Login";
import OruClickLogo from "../../Reusable/OruClickLogo";

const ResponsiveAppBar = ({ isDarkTheme }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ position: "relative" }}>
      <AppBar
        className="customize_header"
        position="static"
        sx={{
          background: isDarkTheme
            ? "linear-gradient(to right, #1a237e, #000000)"
            : "linear-gradient(to right, #ffffff, #f5f7fa)",
          color: isDarkTheme ? "#fff" : "#000",
          fontFamily: "DM Sans",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
          borderRadius: "0 0 15px 15px",
        }}
      >
        <Container>
          <Toolbar
            disableGutters
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.5,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                },
              }}
              onClick={() => navigate("/")}
            >
              <OruClickLogo
                iconSize={{ xs: "28px", sm: "36px", md: "40px" }}
                fontSize={{ xs: "18px", sm: "22px", md: "24px" }}
              />
            </Box>

            <Button
              variant="contained"
              name="staff-login"
              id="staff-login"
              onClick={() => {
                window.location.href = "https://www.login.oruclick.com/?source=peopleSoftware";
              }}
              startIcon={<LoginIcon />}
              sx={{
                textTransform: "none",
                fontWeight: "bold",
                borderRadius: "30px",
                padding: "8px 20px",
                background: isDarkTheme
                  ? "linear-gradient(45deg, #4caf50, #388e3c)"
                  : "linear-gradient(45deg, #66bb6a, #43a047)",
                boxShadow: "0 4px 10px rgba(76, 175, 80, 0.3)",
                transition: "all 0.3s ease",
                "&:hover": {
                  background: isDarkTheme
                    ? "linear-gradient(45deg, #388e3c, #2e7d32)"
                    : "linear-gradient(45deg, #43a047, #388e3c)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 15px rgba(76, 175, 80, 0.4)",
                },
              }}
            >
              Staff Login
            </Button>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
};

export default ResponsiveAppBar;
